import PropTypes from 'prop-types';
import React from 'react';
import { CountriesMap } from './countries_map';
import { CountriesTable } from './countries_table';

// Provides a combined countries panel that has a map and table
export class CountriesPanel extends React.Component {
  static propTypes = {
    countries: PropTypes.array.isRequired,
    countAttribute: PropTypes.string.isRequired,
    dayCount: PropTypes.number.isRequired,
  };

  render() {
    return (
      <div className="panel panel-flat a-fadeInDown">
        <div className="panel-body">
          <div className="u-mv8x">
            <CountriesMap
              countries={this.props.countries}
              countAttribute={this.props.countAttribute}
              dayCount={this.props.dayCount}
            />
          </div>
          <CountriesTable
            countries={this.props.countries}
            dayCount={this.props.dayCount}
          />
        </div>
      </div>
    );
  }
}
